/* ============================================================
   MAAREE cart drawer fix, 22 October 2026.

   The free-gift app (gfg / "Free Gift") injects its gift card
   (div.gfgFreeGiftSideCartWrapperV4) INSIDE the discount code panel,
   which lives in the drawer's fixed footer. On a small phone that card
   (about 180px tall) pushed the checkout button off the bottom of the
   screen and made the footer wider than the screen.

   This moves the card into the scrolling part of the drawer, straight
   after the trust strip, so it scrolls with the products and the
   footer stays short.

   The app re-injects its card every time the drawer re-renders (for
   example after a quantity change), so a MutationObserver moves it
   again each time. Tested 22 Oct: the app does not add a second copy
   after a move, it only re-adds after a re-render.
   ============================================================ */
(function () {
  'use strict';

  var GIFT = '.gfgFreeGiftSideCartWrapperV4';

  function moveGiftCard() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    var card = drawer.querySelector('.cart-drawer__footer ' + GIFT);
    if (!card) return;

    var anchor = drawer.querySelector('.mc-trustzone') || drawer.querySelector('.cart-drawer__items');
    if (!anchor || !anchor.parentNode) return;

    card.classList.add('mc-gift-moved');
    anchor.parentNode.insertBefore(card, anchor.nextSibling);
  }

  function start() {
    moveGiftCard();
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;
    new MutationObserver(function () {
      moveGiftCard();
    }).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
